import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.top');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-top',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.top/view.scss */
/* src/app/component.top/view.scss: no such file or directory */`],
})
export class ComponentTopComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default ComponentTopComponent;